<template>
  <div style="background-color: #fff; height: 97%">
    <ul>
      <li class="fir_li" v-for="item in roleMenus" :key="item.menuCode">
        <div class="head">
          <input
            type="checkbox"
            name="parent"
            :id="'check' + item.menuCode"
            :value="item.menuName"
            @click="checkParent(item.menuCode)"
            :checked="item.checked"
            hidden
          />
          <label class="checkstyle" :for="'check' + item.menuCode"></label>
          <span>{{ item.menuName }}</span>
        </div>
        <ul class="sec_ul">
          <li v-for="secitem in item.child" :key="secitem.menuCode">
            <input
              type="checkbox"
              name="child"
              :id="'check' + secitem.menuCode"
              :value="secitem.menuName"
              @click="
                checkChild('check' + secitem.menuCode, 'check' + item.menuCode)
              "
              :checked="secitem.checked"
              hidden
            />
            <label class="checkstyle" :for="'check' + secitem.menuCode"></label>
            <span>{{ secitem.menuName }}</span>
          </li>
        </ul>
      </li>
      <div class="head checkall">
        <input type="checkbox" id="all" @click="allCheck('all')" hidden />
        <label class="checkstyle" for="all"></label>
        <span>选择全部</span>
      </div>
    </ul>
    <a-button class="login-btn" @click="submit">保存</a-button>
  </div>
</template>

<script>
export default {
  name: "roleSet",
  data() {
    return {
      roleCode: "",
      roleMenus: [],
    };
  },
  created() {
    this.roleCode = this.$route.query.roleCode;
    this.axios
      .post("/roleMenu/queryRoleMenus", {
        roleCode: this.roleCode,
      })
      .then((res) => {
        if (res.data.code == "OK") {
          this.roleMenus = res.data.data;
        } else {
          this.utils.messageInfo(this, "error", res.data.data);
        }
      });
  },
  mounted() {},
  methods: {
    checkParent(menuCode) {
      for (var i = 0; i < this.roleMenus.length; i++) {
        if (this.roleMenus[i].menuCode == menuCode) {
          var child = this.roleMenus[i].child;
          var flag = document.getElementById("check" + menuCode).checked;
          for (var j = 0; j < child.length; j++) {
            if (flag) {
              document.getElementById(
                "check" + child[j].menuCode
              ).checked = true;
            } else {
              document.getElementById(
                "check" + child[j].menuCode
              ).checked = false;
            }
          }
        }
      }
    },
    checkChild(childMenoCode, menuCode) {
      var flag = document.getElementById(childMenoCode).checked;
      if (flag) {
        document.getElementById(menuCode).checked = true;
      }
    },
    allCheck(docId) {
      var flag = document.getElementById(docId).checked;
      var child = document.getElementsByName("child");
      var parent = document.getElementsByName("parent");
      if (flag) {
        for (var i = 0; i < child.length; i++) {
          child[i].checked = true;
        }
        for (var j = 0; j < parent.length; j++) {
          parent[j].checked = true;
        }
      } else {
        for (var n = 0; n < child.length; n++) {
          child[n].checked = false;
        }
        for (var m = 0; m < parent.length; m++) {
          parent[m].checked = false;
        }
      }
    },
    submit() {
      var doc = document.getElementsByName("child");
      var menus = new Array();
      for (var i = 0; i < doc.length; i++) {
        if (doc[i].checked) {
          menus.push(doc[i].id.substring(5, doc[i].id.length));
        }
      }
      this.axios
        .post("/roleMenu/updateRoleMenu", {
          roleCode: this.roleCode,
          menus: menus,
        })
        .then((res) => {
          if (res.data.code == "OK") {
            this.utils.messageInfo(this, "success", "编辑成功！");
            this.$router.go(-1);
          } else {
            this.utils.messageInfo(this, "error", res.data.data);
          }
        });
    },
  },
};
</script>

<style>
.trstyle {
  width: 100%;
  height: auto;
}
.fir_li {
  list-style: none;
  width: 100%;
  margin: 20px auto;
  font-size: 14px;
  color: #555;
  vertical-align: middle;
  text-indent: 20px;
  background: #f8f8f8;
  /* border-left: 1px solid #ccc; */
  width: 100%;
  box-sizing: border-box;
}
.head {
  height: 50px;
  line-height: 50px;
  position: relative;
  /* border:1px solid #ccc; */
  border-left: none;
}
.fir_li span {
  margin-left: 20px;
}
.checkall span {
  margin-left: 20px;
}
.checkstyle {
  position: absolute;
  top: 50%;
  margin-top: -6px;
}
.checkstyle {
  width: 15px;
  height: 15px;
  border: 1px solid #333;
  background: #fff;
}
input[type="checkbox"]:checked + .checkstyle {
  background-image: url(../../../../assets/checked.png);
  background-size: 100%;
  border: 0px solid;
}
.sec_ul {
  width: 100%;
  overflow: hidden;
  height: auto;
  background: #fff;
  display: flex;
  flex-flow: wrap;
}
.sec_ul li {
  list-style: none;
  position: relative;
  height: 50px;
  line-height: 50px;
  width: 200px;
  /* border-right:1px solid #ccc;
  border-bottom:1px solid #ccc; */
  box-sizing: border-box;
}
.login-btn {
  margin-left: 45%;
  width: 80px;
  height: 35px;
  color: #fff;
  background-color: #1890ff;
  border-color: #1890ff;
}
.checkall {
  left: 45%;
}
</style>